import { render, staticRenderFns } from "./FileManagerImageSelect.vue?vue&type=template&id=10f9604e&scoped=true&"
import script from "./FileManagerImageSelect.vue?vue&type=script&lang=js&"
export * from "./FileManagerImageSelect.vue?vue&type=script&lang=js&"
import style0 from "./FileManagerImageSelect.vue?vue&type=style&index=0&id=10f9604e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9604e",
  null
  
)

export default component.exports